export enum SecurityResponseSubscriptionOptions {
  AutoRenewal = 'autoRenewal',
}
